import { createSelector } from 'reselect';

const selectFundingReport = (state) => state.get('fundingReport');

const makeSelectDeleteFundingReportError = () =>
  createSelector(selectFundingReport, (state) =>
    state.getIn(['deleteFundingReport', 'network', 'error']),
  );

const makeSelectDeleteFundingReportLoading = () =>
  createSelector(selectFundingReport, (state) =>
    state.getIn(['deleteFundingReport', 'network', 'loading']),
  );

const makeSelectDeleteFundingReportModal = () =>
  createSelector(selectFundingReport, (state) => state.getIn(['deleteFundingReport', 'modalOpen']));

export {
  makeSelectDeleteFundingReportError,
  makeSelectDeleteFundingReportLoading,
  makeSelectDeleteFundingReportModal,
};
